module.exports = __webpack_public_path__ + "img/20200514_143913.6705f969.jpg";